var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "#07143F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2168 26.1667C28.2168 21.1925 24.7785 23.2233 21.9668 23.2233C19.1551 23.2233 15.7168 21.2442 15.7168 26.1667C15.7168 26.9402 16.0241 27.6821 16.5711 28.2291C17.118 28.776 17.8599 29.0833 18.6335 29.0833H25.3001C26.0737 29.0833 26.8155 28.776 27.3625 28.2291C27.9095 27.6821 28.2168 26.9402 28.2168 26.1667Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9067 20.5117L29.9334 20.5308C29.9334 20.5308 32.1384 16.7208 29.4334 14.5C27.7667 14.5 25.2184 17.25 25.2184 17.25L25.2367 17.2633C23.118 16.6525 20.8704 16.6479 18.7492 17.25C18.7351 17.2375 16.1967 14.5 14.5342 14.5C11.8901 16.6667 13.9267 20.3433 14.0226 20.5142C13.0997 21.9298 12.6895 23.6188 12.8601 25.3C13.0609 27.905 15.2326 30.75 17.8451 30.75H26.0826C28.6951 30.75 30.8676 27.905 31.0676 25.3C31.2405 23.618 30.8307 21.9277 29.9067 20.5117Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8997 27.4167C25.36 27.4167 25.7331 26.857 25.7331 26.1667C25.7331 25.4763 25.36 24.9167 24.8997 24.9167C24.4395 24.9167 24.0664 25.4763 24.0664 26.1667C24.0664 26.857 24.4395 27.4167 24.8997 27.4167Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0658 27.4167C19.526 27.4167 19.8991 26.857 19.8991 26.1667C19.8991 25.4763 19.526 24.9167 19.0658 24.9167C18.6055 24.9167 18.2324 25.4763 18.2324 26.1667C18.2324 26.857 18.6055 27.4167 19.0658 27.4167Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.39ad9f4fc3a987cfb2b7e1b4ad70f645.svg";
export { ForwardRef as ReactComponent };